export default "__VITE_ASSET__8e7eacb0__$_?nuxt_component=async&nuxt_component_name=SvgoHelp3033749__"